import Close from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Grid, IconButton, ListItemButton, Modal, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_SAR2 } from "../../constant/Apipath";
import ClientSARViewModal from "./ClientSARViewModal";
import { BILightGrey } from "../../assets/helpers";
import moment from "moment";

export default function ClientSARViewListingModal({ open, onClose, data }) {
  const [pageNO, setPageNO] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [sarData, setSarData] = useState([]);
  const { loginData, selectedClientData } = useSelector((state) => state?.main);

  useEffect(() => {
    if (open) fetchSAR();
  }, [open]);

  const fetchSAR = async () => {
    let sar = {
      PageNr: pageNO,
      NrOfRecPerPage: 10,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [{ FieldName: "Date", Direction: "DESC" }],
      SearchList: [
        {
          clientEmployeeJobId: data?.id
        }
      ]
    };

    let res = await Postrequestcall(FETCH_CLIENT_SAR2, sar, loginData?.accessToken);

    if (res.status === 200) {
      if (res?.data?.data?.length > 0) {
        setHasMore(true);
        setPageNO((prev) => prev + 1);

        let temp = [...res?.data?.data];

        setSarData((prev) => [...prev, ...temp]);
      } else {
        setHasMore(false);
      }
    }
  };

  const handelClose = () => {
    onClose();
    setPageNO(1);
    setHasMore(true);
    setSarData([]);
  };

  const Listing = ({ item, index }) => {
    const [viewModal, setViewModal] = useState(false);
    const [selectedSarData, setSelectedSarData] = useState({});
    return (
      <div key={index}>
        <Grid
          container
          size={12}
          mb={1}
          style={{
            padding: "0",
            borderRadius: "10px",
            border: "1px solid #e4e4e4"
          }}>
          <ListItemButton
            onClick={() => {
              setViewModal(true);
              setSelectedSarData(item);
            }}
            style={{
              padding: "0",
              borderRadius: "10px"
            }}>
            <Grid padding={1} size={12}>
              <Stack flexDirection={"row"} justifyContent={"space-between"} display={"flex"}>
                <Stack gap={1} direction="row">
                  <Typography variant="p">{dayjs(item?.date).format("MMMM DD, YYYY")}</Typography>
                  <Typography
                    style={{
                      color: "grey"
                    }}
                    variant="p">
                    {moment.utc(item?.time).local().format(" h:mm A")}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </ListItemButton>
        </Grid>
        <ClientSARViewModal
          isOpen={viewModal}
          onClose={() => setViewModal(false)}
          data={data}
          sarData1={selectedSarData}
          reload={() => {
            setPageNO(0);
            setHasMore(true);
            setSarData([]);
            onClose();

            fetchSAR();
          }}
        />
      </div>
    );
  };

  return (
    <>
      <Modal open={open} onClose={handelClose}>
        <div className="client-modal-responsive">
          <div
            style={{
              display: "flex",
              alignItems: "center"
            }}
            className="action-button-container">
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "1rem",
                fontWeight: "bold"
              }}>
              <LocationOnIcon
                style={{
                  color: selectedClientData?.AccentColor,
                  marginRight: "10px"
                }}
              />
              {`${data?.jobCode} - ${data?.jobName}`}
            </Typography>
            <IconButton onClick={() => handelClose()}>
              <Close
                sx={{
                  color:
                    selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                      ? selectedClientData?.AccentColor
                      : BILightGrey
                }}
              />
            </IconButton>
          </div>

          <InfiniteScroll
            dataLength={sarData?.length}
            next={fetchSAR}
            hasMore={hasMore}
            loader={<Loader />}
            height={400}
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              scrollbarWidth: "none"
            }}>
            {sarData?.map((item, index) => (
              <Listing index={index} item={item} key={index} />
            ))}
          </InfiniteScroll>
        </div>
      </Modal>
    </>
  );
}
